import { docReady } from '../helpers/docReady';
import '../../styles/templates/collection.scss';
import { collectionReadMoreDescription } from '../snippets/collectionReadMoreDescription';
import { mainCollection } from '../sections/mainCollection';
docReady(() => {
    // console.log('Collection Template');
    collectionReadMoreDescription();
    mainCollection();
});
